import React from 'react';
import classnames from 'classnames';
import '../../../css/selectbox.less';

/**
 * @param {Function} onFilter Callback
 * @param {(String|Integer)} selected The default value used by the selectbox
 * @param {Array} children Select options
 * @param {Boolean} required Whether to display a asterisk to mark field as required
 * @description A SFC component that renders a selectbox
 */
const GenericSelectBox = ({ onFilter, selected, children, required }, ref) => (
    <div className={
        classnames({
            'form-group': true,
            required,
        })}
    >
        <label className="control-label">
            <select 
                ref={ref}
                defaultValue={selected} 
                onChange={onFilter} 
                className="form-control form-select"
            >
                {children}
            </select>
        </label>
    </div>
);

export default React.forwardRef(GenericSelectBox);
